import React, {useContext, useState, useEffect} from 'react'
import {AppContext} from '../Context';
import moment from 'moment';
import CheckBox from "../../../common-scripts/CustomFields/CheckBox";

/**
 * Step Récapitulatif de vos volontés
 *
 * @param checkReadyForSaving
 * @param texteInfos
 * @param texteGeneralConditions
 * @returns {JSX.Element}
 * @constructor
 */
const StepSummary = ({checkReadyForSaving, texteInfos, texteGeneralConditions}) => {
	const {
		currentStep,
		steps,
		setSteps,
		dispatchStepEvent,
		datas,
		setdatas,
		setshowloader,
		setiframeurl,
		iframeurl,
		showloader,
		scrollToTop,
		gcPdfUrl
	} = useContext(AppContext);
	const [sepultures, setSepultures] = useState([
		{
			is_selected: false,
			libelle: 'Crémation',
			icon_code: 'cr1',
			infobulle: 'La crémation consiste à réduire en cendres le corps du défunt pour ensuite être dispersées ou conservées dans une urne. L\'urne peut être inhumée où scellée sur la sépulture.'
		},
		{
			is_selected: false,
			libelle: 'Inhumation',
			icon_code: 'in',
			infobulle: 'L\'inhumation consiste à placer le cercueil dans une sépulture située le plus souvent dans le cimetière du lieu d\'habitation du défunt, du lieu du décès ou celui du caveau familial.'
		},
	]);
	const [ceremonies, setCeremonies] = useState([
		{is_selected: false, libelle: 'Cérémonie civile', icon_code: 'cc', infobulle: ''},
		{is_selected: false, libelle: 'Cérémonie religieuse', icon_code: 'rel', infobulle: ''},
		{is_selected: false, libelle: 'Aucune cérémonie', icon_code: 'non', infobulle: ''},
	]);

	const [dataStep1, dataStep2, dataStep3] = datas;

	const [generalCondition, setGeneralCondition] = useState(false);

	useEffect(() => {
		checkReadyForSaving(true);
	}, [])

	const electronicSignature = () => {
		const divElement = document.getElementById('gdv-online-form');
	 	const csrfToken = divElement.dataset.csrfToken;
		
		datas[currentStep + 2] = {csrf: csrfToken};
		datas[currentStep] = {summary: ""};
		
		setdatas(datas);
		dispatchStepEvent('NEXT_STEP');
		scrollToTop();
	}
	const downloadDoc = () => {
		dispatchStepEvent('DOWNLOAD');
	}
	const formateDate = (date) => {
		let _date = date.split("-");
		return _date[2] + '-' + _date[1] + '-' + _date[0];
	}
	return (
		<>
			<div id="step-5" className="step-form">

				<div id="step-data_1" className="form-card">
					<div className="card-header">
						Souscripteur :
					</div>
					<div className="card-body">

						<div className="bloc question picto valid">


							<ul className="lvl1">

								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Civilité :  <strong>{dataStep1.civility}</strong>
                                                </span>
                                            </span>

								</li>
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Prénom :  <strong>{dataStep1.firstName}</strong>
                                                </span>
                                            </span>

								</li>
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Nom :  <strong>{dataStep1.lastName}</strong>
                                                </span>
                                            </span>

								</li>
								{dataStep1.birthName != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Nom de naissance :   <strong> {dataStep1.birthName}</strong>
                                                </span>
                                            </span>

								</li>}
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                     Date de naissance :   <strong> {formateDate(dataStep1.birthDate)}</strong>
                                                </span>
                                            </span>

								</li>
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Lieu de naissance :     <strong> {dataStep1.birthPlace}</strong>
                                                </span>
                                            </span>

								</li>
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Téléphone  :   <strong> {dataStep1.phone}</strong>
                                                </span>
                                            </span>

								</li>
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Email :   <strong> {dataStep1.email}</strong>
                                                </span>
                                            </span>

								</li>
								{dataStep1.numContrat != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Numéro de contrat :   <strong> {dataStep1.numContrat}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep1.placeOf != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Lieu-dit  :   <strong> {dataStep1.placeOf}</strong>
                                                </span>
                                            </span>

								</li>}
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Adresse :  <strong> {dataStep1.address} {dataStep1.postalCode} {dataStep1.city} </strong>
                                                </span>
                                            </span>

								</li>

							</ul>

						</div>


					</div>
				</div>

				<div id="step-data_21" className="form-card">
					<div className="card-header">
						Mode de sépulture :
					</div>
					<div className="card-body">

						<div className="bloc question picto valid under-ligne">

							<div className='reponses row'>

								{
									sepultures.map((sep, index) => {
										if (sep.libelle == dataStep2.burialMode.type) {

											return <div key={index} className="col-xs-6 col-lg-6 rep selected">
												<span className={`picto ${sep.icon_code} `}></span>
												<span className="label">
                                                       <span>{sep.libelle}</span>
                                                   </span>
											</div>
										} else {
											return null;
										}
									})
								}
							</div>

							{


								'Crémation' == dataStep2.burialMode.type &&


								<ul className="lvl1">

									<li className="active">
                                                                    <span>
                                                                        <span className="toggle">
                                                                            <i className="fa fa-chevron-right"></i>
                                                                            Destination des cendres  : <strong>{dataStep2.burialMode.cremationInfos.destination}</strong>
                                                                        </span>
                                                                    </span>

									</li>
									{dataStep2.burialMode.cremationInfos.place != '' &&
										<li className="active" style={{whiteSpace: 'pre-line'}}>
                                                                    <span>
                                                                        <span className="toggle">
                                                                            <i className="fa fa-chevron-right"></i>
                                                                            Précisez le lieu  : <strong>{dataStep2.burialMode.cremationInfos.place}</strong>
                                                                        </span>
                                                                    </span>

										</li>}


								</ul>


							}
							{
								'Inhumation' == dataStep2.burialMode.type &&
								<ul className="lvl1">

									{dataStep2.burialMode.burialInfos.nameCemetery != '' && <li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Nom du cimetière  :  <strong>{dataStep2.burialMode.burialInfos.nameCemetery}</strong>
                                                            </span>
                                                        </span>

									</li>}
									{dataStep2.burialMode.burialInfos.address != '' && <li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Adresse du cimetière :  <strong>{dataStep2.burialMode.burialInfos.address}</strong>
                                                            </span>
                                                        </span>

									</li>}
									{dataStep2.burialMode.burialInfos.nameConcesionHolder != '' &&
										<li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Nom du titulaire de la concession : <strong>{dataStep2.burialMode.burialInfos.nameConcesionHolder}</strong>
                                                            </span>
                                                        </span>

										</li>}
									{dataStep2.burialMode.burialInfos.numConcession != '' && <li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Numéro de la concession : <strong>{dataStep2.burialMode.burialInfos.numConcession}</strong>
                                                            </span>
                                                        </span>

									</li>}
									{dataStep2.burialMode.burialInfos.relationshipWithConcessionHolder != '' &&
										<li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Lien de parenté avec le titulaire de la concession : <strong>{dataStep2.burialMode.burialInfos.relationshipWithConcessionHolder}</strong>
                                                            </span>
                                                        </span>

										</li>}
									{dataStep2.burialMode.burialInfos.placesRemaining != '' && <li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Places restantes à ce jour : <strong>{dataStep2.burialMode.burialInfos.placesRemaining}</strong>
                                                            </span>
                                                        </span>

									</li>}
									{dataStep2.burialMode.burialInfos.durationConcession != '' &&
										<li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Durée de la concession  : <strong>{dataStep2.burialMode.burialInfos.durationConcession}</strong>
                                                            </span>
                                                        </span>

										</li>}
									{dataStep2.burialMode.burialInfos.otherDuration != '' && <li className="active">
                                                        <span>
                                                            <span className="toggle">
                                                                <i className="fa fa-chevron-right"></i>
                                                                Autre durée de concession : <strong>{dataStep2.burialMode.burialInfos.otherDuration}</strong>
                                                            </span>
                                                        </span>

									</li>}


								</ul>
							}


						</div>


					</div>
				</div>
				<div id="step-data_22" className="form-card">
					<div className="card-header">
						Cérémonie :
					</div>
					<div className="card-body">
						<div className="bloc question picto valid">

							{
								ceremonies.map((cer, index) => {
									if (cer.libelle == dataStep2.ceremony) {

										return <div key={index} className="col-xs-6 col-lg-6 rep selected">
											<span className={`picto ${cer.icon_code} `}></span>
											<span className="label">
                                                       <span>{cer.libelle}</span>
                                                   </span>
										</div>
									} else {
										return null;
									}
								})
							}
						</div>

					</div>
				</div>
				<div id="step-data_23" className="form-card">
					<div className="card-header">
						Autres dispositions :
					</div>
					<div className="card-body">
						<div className="bloc question picto valid">

							<ul className="lvl1">

								{dataStep2.otherDispositions.floralComposition.status != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Composition florale : <strong>{dataStep2.otherDispositions.floralComposition.status}</strong>
                                            </span>
                                        </span>
								</li>}
								{dataStep2.otherDispositions.floralComposition.type != '' &&
									<li className="active" style={{whiteSpace: 'pre-line'}}>
										Précisions
										: <strong>{dataStep2.otherDispositions.floralComposition.type}  </strong>
									</li>}
								{dataStep2.otherDispositions.typeOfCoffin != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Type de cercueil souhaité :   <strong>{dataStep2.otherDispositions.typeOfCoffin}</strong>
                                            </span>
                                        </span>

								</li>}
								{dataStep2.otherDispositions.funeralHomeStay != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Séjour en Chambre funéraire :  <strong>{dataStep2.otherDispositions.funeralHomeStay}</strong>
                                            </span>
                                        </span>

								</li>}
								{dataStep2.otherDispositions.conservationCare != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Soins de conservation :   <strong>{dataStep2.otherDispositions.conservationCare}</strong>
                                            </span>
                                        </span>

								</li>}
								{dataStep2.otherDispositions.pressNotices != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Avis dans la presse :   <strong>{dataStep2.otherDispositions.pressNotices}</strong>
                                            </span>
                                        </span>

								</li>}
								{dataStep2.otherDispositions.announcement != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Faire-part :   <strong>{dataStep2.otherDispositions.announcement}</strong>
                                            </span>
                                        </span>

								</li>}
								{dataStep2.otherDispositions.otherDispositions != '' &&
									<li className="active" style={{whiteSpace: 'pre-line'}}>
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Autres dispositions :  <strong>{dataStep2.otherDispositions.otherDispositions}</strong>
                                            </span>
                                        </span>

									</li>}
								{dataStep2.authorizeFuneralOrganization != '' && 
									<li className="active">
										<span>
											<span className="toggle">
												<i className="fa fa-chevron-right"></i>
												Je souhaite que mes obsèques soient organisées et réalisées par une agence du Groupe FUNECAP (Roc Eclerc, Pascal Leclerc, Rebillon, réseau France Obsèques) selon les Volontés essentielles et détaillées exprimées dans ce document.
											</span>
										</span>
										
									</li>}		
								{dataStep2.authorizeSensitiveData != '' && <li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                J’autorise le responsable de traitement visé dans les conditions générales à traiter les données sensibles que j’inscris dans le présent formulaire, afin que le mandataire veille au respect de mes Volontés Essentielles et accomplisse toute action impliquée par cette finalité :  <strong>{dataStep2.authorizeSensitiveData ? "Oui" : "Non"}</strong>
                                            </span>
                                        </span>

								</li>}

							</ul>
						</div>


					</div>
				</div>
				<div id="step-data_31" className="form-card">
					<div className="card-header">
						Mandataire
					</div>
					<div className="card-body">
						<div className="bloc question picto valid">

							<p>Vous avez choisi : <strong> {dataStep3.mandator.type}</strong></p>

							{dataStep3.mandator.type == "Un proche" && <ul className="lvl1">

								{dataStep3.mandator.procheInfos.civility != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Civilité : <strong>{dataStep3.mandator.procheInfos.civility}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.firstName != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Prénom : <strong>{dataStep3.mandator.procheInfos.firstName}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.lastName != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Nom : <strong>{dataStep3.mandator.procheInfos.lastName}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.birthName != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Nom de naissance : <strong>{dataStep3.mandator.procheInfos.birthName}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.birthDate != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Date de naissance : <strong>{formateDate(dataStep3.mandator.procheInfos.birthDate)}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.phone != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Téléphone :  <strong>{dataStep3.mandator.procheInfos.phone}</strong>
                                                </span>
                                            </span>

								</li>}
								{dataStep3.mandator.procheInfos.email != '' && <li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Email :  <strong>{dataStep3.mandator.procheInfos.email}</strong>
                                                </span>
                                            </span>

								</li>}
								<li className="active">
                                            <span>
                                                <span className="toggle">
                                                    <i className="fa fa-chevron-right"></i>
                                                    Adresse  :  <strong>  {dataStep3.mandator.procheInfos.address} {dataStep3.mandator.procheInfos.postalCode} {dataStep3.mandator.procheInfos.city}</strong>
                                                </span>
                                            </span>

								</li>
							</ul>

							}

						</div>
					</div>
				</div>
				{dataStep3.personsToPrevent.length > 0 && <div id="step-data_32" className="form-card">
					<div className="card-header">
						Personnes à prévenir au moment du décès :
					</div>
					<div className="card-body">

						{
							dataStep3.personsToPrevent.map((person, index) => {

								return <div key={index} className="bloc question picto valid  under-ligne">
									<ul className="lvl1">

										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Civilité : <strong>{person.civility}</strong>
                                            </span>
                                        </span>

										</li>
										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Prénom : <strong>{person.firstName}</strong>
                                            </span>
                                        </span>

										</li>
										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Nom : <strong>{person.lastName}</strong>
                                            </span>
                                        </span>

										</li>
										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Nom de naissance :  <strong> {person.birthName}</strong>
                                            </span>
                                        </span>

										</li>
										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Date de naissance :  <strong> {formateDate(person.birthDate)}</strong>
                                            </span>
                                        </span>

										</li>

										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Téléphone  :   <strong> {person.phone}</strong>
                                            </span>
                                        </span>

										</li>
										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Email :   <strong> {person.email}</strong>
                                            </span>
                                        </span>

										</li>

										<li className="active">
                                        <span>
                                            <span className="toggle">
                                                <i className="fa fa-chevron-right"></i>
                                                Adresse :  <strong> {person.address} {person.postalCode} {person.city} </strong>
                                            </span>
                                        </span>

										</li>

									</ul>

								</div>


							})
						}


					</div>
				</div>}


			</div>

			<div id="step-3" className="step-form">
				<div className="form-card">
					<div className="card-body">
						{/*<div className="terme">*/}
						{/*	<div dangerouslySetInnerHTML={{__html: texteGeneralConditions}}></div>*/}
						{/*	<div className='term-footer'></div>*/}
						{/*</div>*/}
						<div className="bloc question picto valid upper-ligne">
							<div className="reponses row">
								<div className="rep checkbox ">

									<CheckBox
										checkValue={generalCondition}
										onChange={(value) => {

											setGeneralCondition(!value);

											datas[currentStep - 1] = {generalConditions: !value};
											setdatas(datas);

										}}
										anchorText={'Conditions Générales du Service des Volontés'}
										anchorLink={gcPdfUrl}
										type={'anchor'}
										name="generalCondition"
										texte={'J’accepte les '}/>

								</div>


							</div>


						</div>

					</div>
				</div>


			</div>
			<div className="bottom">

				<div className="prev_next stepper">

					<div>
						<button onClick={electronicSignature}
								disabled={!generalCondition}
								className={`bouton bouton-full bouton-business bouton-picto-r goto_backto ${generalCondition ? 'ready' : 'wait'}`}><span>Signer électroniquement</span>
							<i className="fun-picto fun-picto-arrow-right"></i></button>
					</div>

				</div>
			</div>
			<div className="form-card">
				<div className="card-body">
					<div className="bloc question picto valid ">
						<p dangerouslySetInnerHTML={{__html: texteInfos}}></p>
						<div className="bottom">

							<div className="prev_next stepper">
								<button onClick={downloadDoc} style={{marginRight: '0px'}}
										disabled={!generalCondition}
										className={`bouton-picto-left goto_backto ${generalCondition ? 'ready': 'wait'}`}><i
									className="fa fa-download"></i>Télécharger votre recueil
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

		</>
	)
}

export default StepSummary
